export default __webpack_public_path__ + "static/media/plus-dark.ae5eaa34.svg";